import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';

class ServiceSearchParams extends SearchParamsBase {
  static saveType = 'ServiceSearchParams';
  static iconName = 'fa-solid fa-search';

  initialize() {
    this.OpportunityIdOrName = '';
    this.ServiceIdOrName = '';
    this.ClientIdOrName = '';
    this.UninvoicedOtherFees = '';
    this.OpportunityStatusCode = [];
    this.OpportunityAssignedTo = '';
    this.IsIncluded = '';
    this.UseDateRange = false;
    this.StartDate = dateTimeHelper.addYearsToNowDate(-1);
    this.EndDate = dateTimeHelper.indefiniteDateValue();
    this.ServiceType = [];
  }

  static fieldsInSearchBox = [
    { fieldName: 'ClientIdOrName', label: 'Client Id Or Name', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'OpportunityIdOrName',
      label: 'Opportunity Id or Name',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
    { fieldName: 'ServiceIdOrName', label: 'Service Id Or Name', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'UninvoicedOtherFees',
      label: 'Uninvoiced Other Fees',
      className: 'col-4',
      type: InputTypesEnum.EmptyYesNoSelect,
    },
    {
      fieldName: 'OpportunityStatusCode',
      label: 'Opportunity Status',
      className: 'col-4',
      type: InputTypesEnum.LookupMultiChoice,
      options: 19,
    },
    {
      fieldName: 'OpportunityAssignedTo',
      label: 'Opportunity Assigned To',
      className: 'col-4',
      type: InputTypesEnum.UserSelect,
    },
    {
      fieldName: 'UseDateRange',
      label: 'Search by Modified On date',
      className: 'col-4',
      type: InputTypesEnum.OnOff,
    },
    {
      fieldName: 'StartDate',
      label: 'Modified On Start Date',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (item) => item.UseDateRange,
    },
    {
      fieldName: 'EndDate',
      label: 'Modified On End Date',
      className: 'col-4',
      type: InputTypesEnum.DateWithIndefinite,
      showCondition: (item) => item.UseDateRange,
    },
    { fieldName: 'IsIncluded', label: 'Is Included?', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
    {
      fieldName: 'ServiceType',
      label: 'Service Type',
      className: 'col-4',
      type: InputTypesEnum.LookupMultiChoice,
      options: 15,
    },
  ];

}

export default ServiceSearchParams;
